$(function () {
    if ($('#home').length || $('.home-intro')) {

        var priceSearchHighInput = $('#price-search-high'),
            showAnyPriceCheckbox = $('#show-any-price'),
            priceFilterLabel = $('#price-filter-label'),
            priceSearchSlider = $('#price-search-slider'),
            locationSearchSelect = $('#searchLocation'),
            locationSearchClearContainer = $('.hero-location-search'),
            heroMp4File = $('#home-hero-mp4-file'),
            heroWebmFile = $('#home-hero-webm-file'),
            heroVideoContainer = $('#home-hero-video-container');

        if (heroVideoContainer.length && $(window).width() > 768) {

            var heroVideoObject = document.createElement("video");

            $(heroVideoObject).addClass('hero-video');

            if (heroMp4File.length) {
                var sourceMP4 = document.createElement("source");
                sourceMP4.type = "video/mp4";
                sourceMP4.src = heroMp4File.val();
                heroVideoObject.appendChild(sourceMP4);
            }

            if (heroWebmFile.length) {
                var sourceWebM = document.createElement("source");
                sourceWebM.type = "video/webm";
                sourceWebM.src = heroWebmFile.val();
                heroVideoObject.appendChild(sourceWebM);
            }

            heroVideoObject.autoplay = true;
            heroVideoObject.muted = true;
            heroVideoObject.loop = true;
            heroVideoObject.load();

            var playPromise = heroVideoObject.play();

            if (playPromise !== undefined) {
                playPromise.then(function () {
                    // Automatic playback started!
                }).catch(function (error) {
                    // Automatic playback failed.
                    // Show a UI element to let the user manually start playback.
                });
            }

            heroVideoContainer.append(heroVideoObject);
        }

        locationSearchSelect.on('show.bs.select', function () {
            // $(window).scrollTop(0);
        });

        locationSearchSelect.on('shown.bs.select', function () {
            $('.home-hero-block').addClass('dropdown-open');

            if ($(window).width() < 768) {
                $('body').css('overflow', 'hidden').css('position', 'relative');
                $('html').css('overflow', 'hidden').css('position', 'relative');
            }
        });

        locationSearchSelect.on('hide.bs.select', function () {
            $('body').css('overflow', '').css('position', '');
            $('html').css('overflow', '').css('position', '');
            $('.home-hero-block').removeClass('dropdown-open');

            $('.hero-block').css('position', 'static');
            $('.hero-block').css('max-width', $(window).width());
            setTimeout(function () {
                $('.hero-block').css('position', '');
                $('.hero-block').css('max-width', '');
            }, 300);
        });

        priceSearchSlider.slider({
            range: true,
            min: 0,
            max: priceSearchHighInput.val(),
            step: 10000,
            values: [0, priceSearchHighInput.val()],
            slide: function (event, ui) {

                $('#home_price_search_high').val(ui.values[1]);
                $('#home_price_search_low').val(ui.values[0]);

                $('#price-search-slider .ui-slider-handle:eq(0) .price-range-min').html('$' + window.helpers.nFormatter(ui.values[0], 1));
                if (window.helpers.nFormatter(ui.values[1], 1) === "50M") {
                    $('#price-search-slider .ui-slider-handle:eq(1) .price-range-max').html('$' + window.helpers.nFormatter(ui.values[1], 1) + '+');
                } else {
                    $('#price-search-slider .ui-slider-handle:eq(1) .price-range-max').html('$' + window.helpers.nFormatter(ui.values[1], 1));
                }
                $('.price-range-both').html('<i>$' + window.helpers.nFormatter(ui.values[0], 1) + ' - </i>$' + window.helpers.nFormatter(ui.values[1], 1));

                if (ui.values[0] === ui.values[1]) {
                    $('.price-range-both i').css('display', 'none');
                } else {
                    $('.price-range-both i').css('display', 'inline');
                }

                if (window.helpers.collision($('.price-range-min'), $('.price-range-max')) == true) {
                    $('.price-range-min, .price-range-max').css('opacity', '0');
                    $('.price-range-both').css('display', 'block');
                } else {
                    $('.price-range-min, .price-range-max').css('opacity', '1');
                    $('.price-range-both').css('display', 'none');
                }

            }, stop: function (event, ui) {
                showAnyPriceCheckbox.attr('checked', false);

                if (window.helpers.nFormatter(ui.values[1], 1) === "50M") {
                    priceFilterLabel.html('$' + window.helpers.nFormatter(ui.values[0], 1) + ' - ' + '$' + window.helpers.nFormatter(ui.values[1], 1) + '+');
                } else {
                    priceFilterLabel.html('$' + window.helpers.nFormatter(ui.values[0], 1) + ' - ' + '$' + window.helpers.nFormatter(ui.values[1], 1));
                }
            }, change: function (event, ui) {
                $('#price-search-slider .ui-slider-handle:eq(0) .price-range-min').html('$' + window.helpers.nFormatter(ui.values[0], 1));
                if (window.helpers.nFormatter(ui.values[1], 1) === "50M") {
                    $('#price-search-slider .ui-slider-handle:eq(1) .price-range-max').html('$' + window.helpers.nFormatter(ui.values[1], 1) + '+');
                } else {
                    $('#price-search-slider .ui-slider-handle:eq(1) .price-range-max').html('$' + window.helpers.nFormatter(ui.values[1], 1));
                }

                $('.price-range-both').html('<i>$' + window.helpers.nFormatter(ui.values[0], 1) + ' - </i>$' + window.helpers.nFormatter(ui.values[1], 1));
            }
        });

        $('#price-search-slider .ui-slider-range').append('<span class="price-range-both value"><i style="display: none;">$' + window.helpers.nFormatter(parseInt(priceSearchSlider.slider('values', 0)), 1) + ' - </i>' + window.helpers.nFormatter(parseInt(priceSearchSlider.slider('values', 1)), 1) + '</span>');
        $('#price-search-slider .ui-slider-handle:eq(0)').append('<span class="price-range-min value">$' + window.helpers.nFormatter(parseInt(priceSearchSlider.slider('values', 0)), 1) + '</span>');
        if (window.helpers.nFormatter(parseInt(priceSearchSlider.slider('values', 1)), 1) === "50M") {
            $('#price-search-slider .ui-slider-handle:eq(1)').append('<span class="price-range-max value">$' + window.helpers.nFormatter(parseInt(priceSearchSlider.slider('values', 1)), 1) + '+</span>');
        } else {
            $('#price-search-slider .ui-slider-handle:eq(1)').append('<span class="price-range-max value">$' + window.helpers.nFormatter(parseInt(priceSearchSlider.slider('values', 1)), 1) + '</span>');
        }

        showAnyPriceCheckbox.on('change', function () {
            if (showAnyPriceCheckbox.is(':checked')) {
                $('#home_price_search_high').val(priceSearchHighInput.val());
                $('#home_price_search_low').val(0);
                priceFilterLabel.html('Any Price');
                priceSearchSlider.slider({ values: [0, priceSearchHighInput.val()] });
            }
        });

        $('.dropdown-menu').on('click', function (e) {
            e.stopPropagation();
        });

        var locationSearchSelectHasBeenFormatted = false;

        locationSearchSelect.on('shown.bs.select', function () {
            if (!locationSearchSelectHasBeenFormatted) {
                var locationRegionHeadings = $('#home-location-search-form').find('.list-col-group-heading');
                locationRegionHeadings.each(function () {
                    $(this).parent('li').addClass('optgroup-heading');
                    $(this).append('<span class="select-all-right">Select Region</span>');
                });
                locationSearchSelectHasBeenFormatted = true;
            }
        });

        locationSearchSelect.on('change', function () {
            var showAll = false,
                selectRegion = false,
                region = '',
                regionCheck = '',
                values = locationSearchSelect.val();

            for (var key in values) {
                if (values.hasOwnProperty(key)) {
                    switch (values[key]) {
                        case "show-all":
                            showAll = true;
                            break;
                        case "Southeast":
                            selectRegion = true;
                            region = "southeast";
                            regionCheck = 'Southeast';
                            break;
                        case "Southwest":
                            selectRegion = true;
                            region = "southwest";
                            regionCheck = 'Southwest';
                            break;
                        case "Pacific":
                            selectRegion = true;
                            region = "pacific";
                            regionCheck = 'Pacific';
                            break;
                        case "Rocky Mountains":
                            selectRegion = true;
                            region = "rocky-mountains";
                            regionCheck = 'Rocky Mountains';
                            break;
                        case "Northeast":
                            selectRegion = true;
                            region = "northeast";
                            regionCheck = 'Northeast';
                            break;
                        case "Plains/Midwest":
                            selectRegion = true;
                            region = "plains-midwest";
                            regionCheck = 'Plains/Midwest';
                            break;
                        case "International":
                            selectRegion = true;
                            region = "international";
                            regionCheck = "International";
                            break;
                    }
                }
            }

            if (showAll) { locationSearchSelect.selectpicker('deselectAll'); }

            if (selectRegion) {
                $('a.opt.list-col-' + region).each(function () {
                    $(this).click();
                });
            }

            if (locationSearchSelect.val() !== null && locationSearchSelect.val().length) {
                locationSearchClearContainer.find('.bootstrap-select').addClass('active');
                $(window).resize();
            } else {
                locationSearchClearContainer.find('.bootstrap-select').removeClass('active');
                $(window).resize();
            }
        });

        $('#home-location-search-form').on('submit', function () {
            window.helpers.gaEvent('Property-search:home', 'search-form-submitted', '');
        });

    }
});
